import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ECIview, ECIMinimalRef, EciStore } from "../domain/eci.model";
import AppConstants from "@src/utils/app.constants";
import { ApplicationResponse } from "@src/common/domain/common.model";
import api from "@src/common/services/api.service";

export const addECITemplateList = createAsyncThunk<void, any>(
  "eciTemplate/addECIemplate",
  async (payload: any) => {
    const response = await api.post<ApplicationResponse<ECIMinimalRef[]>>(
      `${AppConstants.api}/template/create`,
      payload
    );
  }
);

export const updateECITemplateList = createAsyncThunk<void, { id: string; data: any }>(
  "eciTemplate/updateECITemplateList",
  async ({ id, data }) => {
    try {
      const response = await api.put<ApplicationResponse<any>>(
        `${AppConstants.api}/template/update?id=${id}`,
        data
      );


      return; 
    } catch (error) {
      // return rejectWithValue(error.response?.data || error.message);
    }
  }
);
// export const updateECITemplateList = createAsyncThunk<void, any>(
//   "eciTemplate/updateECIemplate",
//   async (payload: any) => {
//     const response = await api.post<ApplicationResponse<ECIMinimalRef[]>>(
//       `${AppConstants.api}/ECI/update`,
//       payload
//     );
//   }
// );

export const ViewECITemplateList = createAsyncThunk<any, string>(
  "eciTemplate/ViewECITemplate",
  async (id) => {
    const response = await api.get<any>(
      `${AppConstants.api}/template/info?id=${id}`
    );
    return response.data.data || {};
  }
);
export const updateECIList = createAsyncThunk<void, any>("eciTemplate/updateECI",
 async (payload: any) => {
    const response = await api.put<ApplicationResponse<any[]>>(`${AppConstants.api}/template/update`, payload)
})
export const fetchEciTemplateList = createAsyncThunk<any[], void>(
  "eciTemplate/fetchEciTemplate",
  async () => {
    const response = await api.get<ApplicationResponse<any[]>>(
      `${AppConstants.api}/template/list?type=ECI`
    );
    return response.data.data || [];
  }
);

const eciTemplateSlice = createSlice({
  name: "eciTemplate",
  initialState: {
    minimal: { status: "loading", error: null, data: [] },
    eciViewMinimal: { status: "loading", error: null, data: {} },
  } as EciStore,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchEciTemplateList.pending, (state) => {
        state.minimal = {
          status: "loading",
          data: [],
          error: null,
        };
      })
      .addCase(fetchEciTemplateList.fulfilled, (state, action) => {
        state.minimal = {
          status: "idle",
          data: action.payload,
          error: null,
        };
      })
      .addCase(fetchEciTemplateList.rejected, (state, action) => {
        state.minimal = {
          status: "failed",
          data: [],
          error: action.error,
        };
      })
      .addCase(ViewECITemplateList.pending, (state) => {
        state.eciViewMinimal = {
          status: "loading",
          data: {} ,
          error: null,
        };
      })
      .addCase(ViewECITemplateList.fulfilled, (state, action) => {
        state.eciViewMinimal = {
          status: "idle",
          data: { ...action.payload },
          error: null,
        };
      })
      .addCase(ViewECITemplateList.rejected, (state, action) => {
        state.eciViewMinimal = {
          status: "failed",
          data: [],
          error: action.error,
        };
      });
  },
});

export default eciTemplateSlice.reducer;
